import "vue";
import { useToast as r } from "vue-toastification";
import { TOAST_VARIANT as n } from "../toast-variants.js";
import { TOAST_CLASS_NAME as a } from "../../constants/toast-class-name.js";
import c from "../components/toast-icons/toast-success-icon.vue.js";
import i from "../components/toast-icons/toast-warning-icon.vue.js";
import m from "../components/toast-icons/toast-info-icon.vue.js";
import { ToastContentCreator as T } from "../toast-content-creator/toast-content-creator.js";
class N {
  toast;
  constructor() {
    this.toast = r();
  }
  /**
   * Shows a success toast notification.
   *
   * @param toastContent the content of the toast notification. Either an object of type IToastNotificationContent or a component.
   * @returns a success toast (TOAST_VARIANT.POSITIVE)
   */
  showSuccessToast(t) {
    const o = {
      toastClassName: `${a} ${n.POSITIVE}`,
      icon: c
    }, s = this.createToastContentComponent(t), e = this.checkIfToastHasAction(s, o);
    return this.toast.success(s, e);
  }
  /**
   * Shows a warning toast notification.
   *
   * @param toastContent the content of the toast notification. Either an object of type IToastNotificationContent or a component.
   * @returns a warning toast (TOAST_VARIANT.NEGATIVE)
   */
  showWarningToast(t) {
    const o = {
      toastClassName: `${a} ${n.NEGATIVE}`,
      icon: i
    }, s = this.createToastContentComponent(t);
    return this.toast.warning(s, o);
  }
  /**
   * Shows a default toast notification.
   *
   * @param toastContent the content of the toast notification. Either an object of type IToastNotificationContent or a component.
   * @returns a default toast (TOAST_VARIANT.NEUTRAL)
   */
  showDefaultToast(t) {
    const o = {
      icon: !1,
      toastClassName: `${a} ${n.NEUTRAL}`
    }, s = this.createToastContentComponent(t), e = this.checkIfToastHasAction(s, o);
    return this.toast(s, e);
  }
  /**
   * Shows a info toast notification.
   *
   * @param toastContent the content of the toast notification. Either an object of type IToastNotificationContent or a component.
   * @returns an info toast (TOAST_VARIANT.INFORMATIVE)
   */
  showInfoToast(t) {
    const o = {
      toastClassName: `${a} ${n.INFORMATIVE}`,
      icon: m
    }, s = this.createToastContentComponent(t);
    return this.toast.info(s, o);
  }
  /**
   *  Dismisses all the toasts.
   */
  clearAllToasts() {
    this.toast.clear();
  }
  /**
   * Creates the component out of the given content for a  Toast Notification.
   *
   * @param content the content of the toast notification type of IToastNotificationContent
   * @returns defineComponent, Toast Content component to be used in the toast notifications.
   */
  createToastContentComponent(t) {
    return "message" in t ? T.createComponent(t) : t;
  }
  /**
   * Checks if the Toast has an action button and resets the timeout value to 10 seconds.
   *
   * @param content the content component of a toast notification.
   * @param options the toasts plugin options to reset.
   * @returns the plugin options with the timeout value.
   */
  checkIfToastHasAction(t, o) {
    return t.props.buttonText !== void 0 && (o.timeout = 1e4), o;
  }
}
export {
  N as ToastService
};
//# sourceMappingURL=toast-service.js.map
